/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const state = {};

export const mutations = {};

export const actions = {
  async fetch({}, payloads) {
    let url = `/psp/gtk/pkp`;
    if (payloads.attr && payloads.attr.endpoint) {
      url += payloads.attr.endpoint;
    }

    const { data } = await http.get(`${url}?${queryString(payloads.params)}`);
    return data;
  },

  async fetchWakasek({}, payload) {
    const { data } = await http.get(`/psp/gtk/pkp/wakasek?${queryString(payload.params)}`);
    return data;
  },

  actions({}, payload) {
    const url = `/psp/gtk/pkp/${payload.aksi}`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  async detail({}, payload) {
    const { data } = await http.get(`/psp/gtk/pkp/${payload.id}?sekolah_id=${payload.sekolah_id}`);
    return data;
  },
};
